import React, { useEffect, useRef } from "react";
import { Checkbox, ComboBox, TooltipHost } from "@fluentui/react";
import { t } from "i18next";
import ClearIcon from "../../components/SVGComponents/ClearIcon";
import { MODEL_OPTIONS, USERTYPES } from "../../constants/Constants";

const ProductivityGainFilters = (props) => {
  const {
    modalityList,
    modalityIds,
    chartType,
    setModalityIds,
    setAlertSuccessModal,
    alertSuccessModal,
    handleClearButtonForModality,
    onClickOutside,
  } = props;
  const ref = useRef(null);

  const NORMALITY_OPTIONS = [
    { key: "total", text: "All" },
    { key: "normal", text: "Normal" },
    { key: "abnormal", text: "Abnormal" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div
      className="filter-popup-study-list"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "0px",
        backgroundColor: "var(--side-tab-active-color)" ,
      }}
      ref={ref}
    >
      {/* {(props.chartType === "study_throughput" || props.chartType === "ai_result" )&& (
        <Checkbox
          label={t("productivity-gain.hourly")}
          checked={props.filterObjInChartComponent.fullDay}
          onChange={(e, checked) => {
            props.setFilterObjInChartComponent((prev) => ({
              ...prev,
              fullDay: checked,
            }));
          }}
        />
      )} */}

      {props.annotationList != undefined && (
        <>
          <div className="pathology-filter-section-analytics align-filter-section" style={{ width: "200px" }}>
            <ComboBox
              selectedKey={props.pathologyIds}
              placeholder="Select Findings"
              options={[...props.annotationList]}
              multiSelect
              calloutProps={{ doNotLayer: true }}
              allowFreeInput
              autoComplete="on"
              onChange={(e, option) => {
                let selected = option?.selected;
                if (selected && props.pathologyIds.length >= 6) {
                  props.setAlertSuccessModal(() => {
                    const newItem = { ...props.alertSuccessModal };
                    newItem.show = true;
                    newItem.heading = "Error";
                    newItem.description = t(
                      "analytics.max-pathologies-selected"
                    );
                    return newItem;
                  });
                  return;
                }
                if (option) {
                  props.setPathologyIds((prevSelectedKeys) =>
                    selected
                      ? [...prevSelectedKeys, option.key]
                      : prevSelectedKeys.filter((k) => k !== option.key)
                  );
                }
              }}
            />
          </div>
        </>
      )}
      {props.role != USERTYPES.RADIOLOGIST &&
        props.providerList != undefined && (
          <>
            <div className="client-filter-section-analytics align-filter-section" style={{ width: "200px" }}>
              <ComboBox
                selectedKey={props.providerIds}
                placeholder="Select Provider"
                options={[...props.providerList]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;

                  if (selected && props.providerIds.length >= 6) {
                    props.setAlertSuccessModal(() => {
                      const newItem = { ...props.alertSuccessModal };
                      newItem.show = true;
                      newItem.heading = "Error";
                      newItem.description = t(
                        "analytics.max-providers-selected"
                      );
                      return newItem;
                    });
                    return;
                  }
                  if (option) {
                    props.setProviderIds((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
            </div>
          </>
        )}
      {props.clientList != undefined && (
        <>
          <div className="client-filter-section-analytics align-filter-section" style={{ width: "200px" }}>
            <ComboBox
              selectedKey={props.clientIds}
              placeholder={`${
                props.role === USERTYPES.ADMIN ? "Select Firm" : "Select Client"
              }`}
              options={[...props.clientList]}
              multiSelect
              calloutProps={{ doNotLayer: true }}
              allowFreeInput
              autoComplete="on"
              onChange={(e, option) => {
                let selected = option?.selected;
                if (option) {
                  props.setClientIds((prevSelectedKeys) =>
                    selected
                      ? [...prevSelectedKeys, option.key]
                      : prevSelectedKeys.filter((k) => k !== option.key)
                  );
                }
              }}
            />
          </div>
        </>
      )}
      {modalityList !== undefined && (
        <div
          className="modality-filter-section-analytics align-filter-section"
          style={{ flexDirection: "row",width:"153px" }}
        >
          <ComboBox
            selectedKey={modalityIds}
            placeholder="Select Modality"
            options={[...modalityList]}
            multiSelect
            calloutProps={{ doNotLayer: true }}
            label={
              chartType === "edit_reports_count" ||
              chartType === "returned_studies_count" ||
              chartType === "raised_alert_count"
                ? "Select Modality"
                : ""
            }
            allowFreeInput
            autoComplete="on"
            onChange={(e, option) => {
              let selected = option?.selected;
              // if (
              //   chartType !== "edit_reports_count" &&
              //   chartType !== "returned_studies_count" &&
              //   chartType !== "raised_alert_count" &&
              //   selected &&
              //   modalityIds.length >= 3
              // ) {
              //   setAlertSuccessModal(() => ({
              //     ...alertSuccessModal,
              //     show: true,
              //     heading: "Error",
              //     description: t("analytics.max-modalities-selected"),
              //   }));
              //   return;
              // }

              if (option) {
                setModalityIds((prevSelectedKeys) =>
                  selected
                    ? [...prevSelectedKeys, option.key]
                    : prevSelectedKeys.filter((k) => k !== option.key)
                );
              }
            }}
          />

          {(chartType === "edit_reports_count" ||
            chartType === "returned_studies_count" ||
            chartType === "raised_alert_count") && (
            <div
              className="ms-sm12 ms-md8 ms-lg6 ms-xl2"
              onClick={handleClearButtonForModality}
              style={{
                alignItems: "flex-end",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <TooltipHost content="Clear">
                <ClearIcon></ClearIcon>
              </TooltipHost>
            </div>
          )}
        </div>
      )}
      {props.xrayBodyParts != undefined &&
        (props.chartType === "study_throughput" ||
          props.chartType === "radiologist_tat_trend" ||
          props.chartType === "ai_result" ||
          props.chartType === "tat_analysis" ||
          props.chartType === "ai_tat_analysis") && (
          <>
            <div
              className="bodypart-filter-section-analytics align-filter-section"
              style={{ flexDirection: "row",width:"153px"}}
            >
              <ComboBox
                selectedKey={props.bodyParts}
                placeholder="Select Body Parts"
                options={[...props.xrayBodyParts]}
                multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    props.setBodyParts((prevSelectedKeys) =>
                      selected
                        ? [...prevSelectedKeys, option.key]
                        : prevSelectedKeys.filter((k) => k !== option.key)
                    );
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" ||
                props.chartType == "returned_studies_count" ||
                props.chartType == "raised_alert_count") && (
                <div
                  className="ms-sm12 ms-md8 ms-lg6 ms-xl2"
                  onClick={() => handleClearButtonForModality()}
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <TooltipHost content="Clear">
                    <ClearIcon></ClearIcon>
                  </TooltipHost>
                </div>
              )}
            </div>
          </>
        )}

        {(props.chartType === "ai_tat_analysis" ) && (
          <>
            <div
              className="bodypart-filter-section-analytics align-filter-section"
              style={{ flexDirection: "row" ,width: "103px"}}
            >
              <ComboBox
                selectedKey={props.normality}
                placeholder="Select AI Result"
                options={NORMALITY_OPTIONS}
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  if (option) {
                    props.setNormality(option.key);
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" ||
                props.chartType == "returned_studies_count" ||
                props.chartType == "raised_alert_count") && (
                <div
                  className="ms-sm12 ms-md8 ms-lg6 ms-xl2"
                  onClick={() => handleClearButtonForModality()}
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <TooltipHost content="Clear">
                    <ClearIcon></ClearIcon>
                  </TooltipHost>
                </div>
              )}
            </div>
          </>
        )} 
      {(props.chartType === "ai_result" ||
          props.chartType === "ai_tat_analysis") && (
          <>
            <div
              className="bodypart-filter-section-analytics align-filter-section"
              style={{ flexDirection: "row",width:"153px"}}
            >
              <ComboBox
                selectedKey={props.aiModel}
                placeholder="Select Models"
                options={MODEL_OPTIONS}
                // multiSelect
                calloutProps={{ doNotLayer: true }}
                allowFreeInput
                autoComplete="on"
                onChange={(e, option) => {
                  let selected = option?.selected;
                  if (option) {
                    // props.setAiModel((prevSelectedKeys) =>
                    //   selected
                    //     ? [...prevSelectedKeys, option.key]
                    //     : prevSelectedKeys.filter((k) => k !== option.key)
                    // );
                    if (option) {
                        // props.setAiModel(option.key); // set a single value
                          props.setAiModel([option.key]); // change it to array bcz backend expect array
                      }
                  }
                }}
              />
              {(props.chartType == "edit_reports_count" ||
                props.chartType == "returned_studies_count" ||
                props.chartType == "raised_alert_count") && (
                <div
                  className="ms-sm12 ms-md8 ms-lg6 ms-xl2"
                  onClick={() => handleClearButtonForModality()}
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <TooltipHost content="Clear">
                    <ClearIcon></ClearIcon>
                  </TooltipHost>
                </div>
              )}
            </div>
          </>
        )}

    </div>
  );
};

export default ProductivityGainFilters;
